const menuToggle = document.querySelector("#header-menu-toggle");

menuToggle &&
    menuToggle.addEventListener("click", () => {
        document.querySelector("#header-menu-aside").classList.remove("hidden");
        document.querySelector(".overlay-screen").classList.remove("hidden");
    });

document
    .querySelector("#header-menu-aside-close")
    .addEventListener("click", () => {
        document.querySelector("#header-menu-aside").classList.add("hidden");
        document.querySelector(".overlay-screen").classList.add("hidden");
        document
            .querySelector(".overlay-screen")
            .style.removeProperty("z-index");
    });

const headerMenusAside = document.querySelectorAll(".header-menu-aside-toggle");

headerMenusAside.forEach(function (elem) {
    elem &&
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            const list = document.querySelector(
                "#header-menu-aside-list" + elem.id,
            );
            const svg = elem.querySelector("svg");

            if (list.classList.contains("hidden")) {
                list.classList.remove("hidden");
                svg.style.transform = "rotate(180deg)";
            } else {
                list.classList.add("hidden");
                svg.style.transform = "rotate(0deg)";
            }
        });
});

const headerMenus = document.querySelectorAll(".header-menu-toggle");
const dropdown = document.querySelector(".header-menus-dropdown");
let timer;

// const menuSingleLinks = document.querySelectorAll(".header-menu-single");
// menuSingleLinks.forEach((elem) => {
//     elem &&
//         elem.addEventListener("mouseenter", () => {
//             if (!dropdown.classList.contains("hidden")) {
//                 dropdown.classList.add("hidden");
//             }

//             headerMenus.forEach((menu) => {
//                 menu.classList.remove("active");
//             });

//             document.querySelector(".overlay-screen").classList.add("hidden");
//         });
// });

headerMenus.forEach(function (elem) {
    elem &&
        elem.addEventListener("mouseenter", () => {
            clearTimeout(timer);
            dropdown.classList.remove("hidden");

            document
                .querySelectorAll(".header-menu-dropdown")
                .forEach((menu) => {
                    if (menu.id != elem.id) {
                        menu.classList.add("hidden");
                    }
                });

            resetHeaderMenuTitles();

            elem.classList.add("active");
            document
                .querySelector("#header-menu-dropdown-" + elem.id)
                .classList.remove("hidden");
            document
                .querySelector(".overlay-screen")
                .classList.remove("hidden");
            document.querySelector(
                "#header-menu-toggle-icon-" + elem.id,
            ).children[0].style.transform = "rotate(180deg)";
        });

    elem &&
        elem.addEventListener("mouseleave", () => {
            timer = setTimeout(() => {
                onMouseLeaveMenu();
            }, 300);
        });
});

function onMouseLeaveMenu() {
    dropdown.classList.add("hidden");
    document.querySelector(".overlay-screen").classList.add("hidden");
    resetHeaderMenuTitles();
}

function onMouseEnterMenu() {
    dropdown.classList.remove("hidden");
    document.querySelector(".overlay-screen").classList.remove("hidden");

    document.querySelectorAll(".header-menu-dropdown").forEach((menu) => {
        if (!menu.classList.contains("hidden")) {
            const split = menu.id.split("-");
            const i = split[split.length - 1];
            document.querySelector(
                "#header-menu-toggle-icon-" + i,
            ).children[0].style.transform = "rotate(180deg)";

            headerMenus.forEach((menu) => {
                if (menu.id == i) {
                    menu.classList.add("active");
                }
            });
        }
    });
}

dropdown &&
    dropdown.addEventListener("mouseleave", () => {
        timer = setTimeout(() => {
            onMouseLeaveMenu();
        }, 300);
    });

dropdown &&
    dropdown.addEventListener("mouseenter", () => {
        onMouseEnterMenu();
        clearTimeout(timer);
    });

// Close aside menu on outside click
document.addEventListener("click", (e) => {
    // Medium screen
    if (window.innerWidth >= 768) return;

    if (
        !document.querySelector("#header-menu-aside").contains(e.target) &&
        !document.querySelector("#header-menu-toggle").contains(e.target)
    ) {
        document.querySelector("#header-menu-aside").classList.add("hidden");
        document.querySelector(".overlay-screen").classList.add("hidden");
        document
            .querySelector(".overlay-screen")
            .style.removeProperty("z-index");
    }
});

function resetHeaderMenuTitles() {
    document.querySelectorAll(".header-menu-toggle-icon").forEach((icon) => {
        icon.children[0].style.transform = "rotate(0deg)";
    });

    headerMenus.forEach((menu) => {
        menu.classList.remove("active");
    });
}
